import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Leaf, Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
import { LOGO_URL, CONTACT, SERVICES } from "@/data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="relative z-10 bg-brand-green text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <div className="bg-white rounded-2xl inline-flex p-3 mb-5">
          <img src={LOGO_URL} alt="EXORA" className="h-10 w-auto" />
        </div>
        <p className="text-white/70 text-sm leading-relaxed max-w-xs">
          Eco-conscious, licensed pest control protecting homes and businesses across Surrey & Metro Vancouver.
        </p>
        <div className="flex items-center gap-2 mt-5 text-brand-gold text-sm font-semibold">
          <Leaf className="h-4 w-4" /> Eco-Conscious Solutions · Pest Free Results
        </div>
        <div className="flex gap-3 mt-6">
          {[Facebook, Instagram, Twitter, Linkedin].map((Icon, i) => (
            <a key={i} href="#" className="h-9 w-9 rounded-full bg-white/10 hover:bg-brand-gold hover:text-brand-green flex items-center justify-center transition-colors">
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>

      <div>
        <h4 className="font-heading font-bold text-lg mb-4">Services</h4>
        <ul className="space-y-2">
          {SERVICES.slice(0, 7).map((s) => (
            <li key={s.slug}>
              <Link to="/services" className="text-white/70 hover:text-brand-gold text-sm transition-colors">{s.name}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-heading font-bold text-lg mb-4">Company</h4>
        <ul className="space-y-2">
          {[["About Us", "/about"], ["Service Areas", "/service-areas"],
            ["Pest Guide", "/pest-guide"], ["Blog", "/blog"], ["Free Inspection", "/request-inspection"]].map(([l, to]) => (
            <li key={to}><Link to={to} className="text-white/70 hover:text-brand-gold text-sm transition-colors">{l}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="font-heading font-bold text-lg mb-4">Get in Touch</h4>
        <ul className="space-y-3 text-sm text-white/70">
          <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-brand-gold" /><a href={`tel:${CONTACT.phoneRaw}`} className="hover:text-brand-gold">{CONTACT.phone}</a></li>
          <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-brand-gold" /><a href={`tel:${CONTACT.phoneAltRaw}`} className="hover:text-brand-gold">{CONTACT.phoneAlt}</a></li>
          <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-brand-gold" /><a href={`mailto:${CONTACT.email}`} className="hover:text-brand-gold">{CONTACT.email}</a></li>
          <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-brand-gold" /><span>{CONTACT.address}</span></li>
          <li className="flex items-start gap-3"><Clock className="h-4 w-4 mt-0.5 text-brand-gold" /><span>{CONTACT.hours}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-white/50 text-xs">
        <span>© {new Date().getFullYear()} EXORA Pest Control. Licensed & Insured. All rights reserved.</span>
        <span className="flex items-center gap-4"><span>Privacy</span><span>Terms</span><span>Accessibility</span></span>
      </div>
    </div>
  </footer>
);
